"use strict";

var _taggedTemplateLiteral = require("/root/icatu-frontend/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

function _templateObject4() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n        padding: ", "px ", "px;\n        min-height: ", "px;\n\n        ", "\n      "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n        padding: ", "px ", "px;\n        min-height: ", "px;\n\n        ", "\n      "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        height: ", "px;\n        padding: ", "px ", "px;\n        min-height: ", "px;\n\n        ", "\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.densities = void 0;

var _stylitas = require("@creditas/stylitas");

var _consts = require("./consts"); // TODO: replace with Design System spacing/density Tokens


var X_PADDING = 16;
var FOCUSED_X_PADDING = X_PADDING - _consts.FOCUSED_BORDER_DELTA;
var DEFAULT_Y_PADDING = 16;
var COMFORTABLE_Y_PADDING = 8;
var COMPACT_Y_PADDING = 4;
var DEFAULT_HEIGHT = 80;
var COMFORTABLE_HEIGHT = DEFAULT_HEIGHT - (DEFAULT_Y_PADDING - COMFORTABLE_Y_PADDING) * 2;
var COMPACT_HEIGHT = COMFORTABLE_HEIGHT - (COMFORTABLE_Y_PADDING - COMPACT_Y_PADDING) * 2;

var densities = function densities(_ref) {
  var size = _ref.size,
      readOnly = _ref.readOnly,
      height = _ref.height;

  switch (size) {
    case 'default':
      return (0, _stylitas.css)(_templateObject(), height != null ? height : DEFAULT_HEIGHT, DEFAULT_Y_PADDING, X_PADDING, DEFAULT_HEIGHT, !readOnly && ":focus-within {\n              padding: ".concat(DEFAULT_Y_PADDING - _consts.FOCUSED_BORDER_DELTA, "px\n              ").concat(FOCUSED_X_PADDING, "px;\n            }"));

    case 'comfortable':
      return (0, _stylitas.css)(_templateObject2(), height != null ? height : COMFORTABLE_HEIGHT, COMFORTABLE_Y_PADDING, X_PADDING, COMFORTABLE_HEIGHT, !readOnly && ":focus-within {\n              padding: ".concat(COMFORTABLE_Y_PADDING - _consts.FOCUSED_BORDER_DELTA, "px\n                ").concat(FOCUSED_X_PADDING, "px;\n            }"));

    case 'compact':
      return (0, _stylitas.css)(_templateObject3(), height != null ? height : COMPACT_HEIGHT, COMPACT_Y_PADDING, X_PADDING, COMPACT_HEIGHT, !readOnly && ":focus-within {\n              padding: ".concat(COMPACT_Y_PADDING - _consts.FOCUSED_BORDER_DELTA, "px\n                ").concat(FOCUSED_X_PADDING, "px;\n            }"));

    default:
      return (0, _stylitas.css)(_templateObject4());
  }
};

exports.densities = densities;